import { render, staticRenderFns } from "./newlanding.vue?vue&type=template&id=21206ffe&scoped=true&"
import script from "./newlanding.vue?vue&type=script&lang=js&"
export * from "./newlanding.vue?vue&type=script&lang=js&"
import style0 from "./newlanding.vue?vue&type=style&index=0&id=21206ffe&scoped=true&lang=css&"
import style1 from "./newlanding.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21206ffe",
  null
  
)

export default component.exports